const STORAGE_KEY = "read_notification_ids";

export function getReadIds(): number[] {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : [];
  } catch {
    return [];
  }
}

export function markAllRead(ids: number[]) {
  const existing = new Set(getReadIds());
  ids.forEach((id) => existing.add(id));
  localStorage.setItem(STORAGE_KEY, JSON.stringify(Array.from(existing)));
}

export function getUnreadCount(ids: number[]): number {
  const read = new Set(getReadIds());
  return ids.filter((id) => !read.has(id)).length;
}
